import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';

import iconLogo from '../images/IconLogo.png';
import cross from '../images/Cross.svg';

import { useIconSwapService } from './IconSwapService.jsx';

export const LoginModal = ({
  isModalOpen,
  closeModal,
}: LoginModalPropTypes) => {
  const { handleLogin } = useIconSwapService();

  return (
    <Modal isOpen={isModalOpen} onRequestClose={closeModal} style={modalStyled}>
      <ModalHeader>
        <TextWrapper>
          <ModalHeading>Log in to start swapping</ModalHeading>
          <ModalText>
            To create a swap or buy a swap you must first log in to your wallet
          </ModalText>
        </TextWrapper>
        <CrossImage src={cross} alt="Close" onClick={() => closeModal()} />
      </ModalHeader>
      <ModalBody>
        <LoginButton
          onClick={() => {
            // @ts-ignore
            handleLogin();
          }}
        >
          <IconLogo src={iconLogo} alt="Logo" />
          <LoginButtonText>Log in with ICON</LoginButtonText>
        </LoginButton>

        {/* <ButtonDivider>
          <Line />
          <DividerText>OR</DividerText>
          <Line />
        </ButtonDivider>

        <LoginButton>
          <LoginButtonText>Log in with Ledger</LoginButtonText>
        </LoginButton> */}
      </ModalBody>
    </Modal>
  );
};

export default LoginModal;

type LoginModalPropTypes = {
  isModalOpen: boolean;
  closeModal: () => void;
};

const modalStyled = {
  content: {
    top: '50%',
    left: '50%',
    // height: '392px',
    height: '300px',
    width: '556px',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    overflow: 'hidden',
  },
  overlay: {
    backgroundColor: 'rgba(33, 33, 33, 0.8)',
  },
};

const ModalHeader = styled.div`
  height: 135px;
  background-color: #ffffff;
  padding: 30px;
  display: flex;
  flex-direction: row;
`;

const ModalHeading = styled.h3`
  font-family: 'Avenir Next';
  font-size: 26px;
  margin-bottom: 15px;
`;

const ModalText = styled.span`
  font-family: 'Avenir Next';
  font-size: 16px;
`;

const ModalBody = styled.div`
  background-color: #f1f8fc;
  height: 256px;
  padding-top: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const LoginButton = styled.button`
  :focus {
    outline: none;
  }
  border: none;
  width: 300px;
  height: 50px;
  background-color: #007d81;
  border-radius: 4px;
`;

const LoginButtonText = styled.span`
  font-family: 'Avenir Next';
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
`;

const IconLogo = styled.img`
  height: 30px;
  width: 30px;
  margin-right: 10px;
`;

const TextWrapper = styled.div``;

const CrossImage = styled.img`
  height: 14.82px;
  width: 14px;
  margin-left: auto;
  cursor: pointer;
`;

const ButtonDivider = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 56px;
  width: 300px;
`;

const Line = styled.hr`
  width: 118px;
  border-top: 1px solid #e8ebec;
`;

const DividerText = styled.span`
  margin-left: 22px;
  margin-right: 22px;
  font-family: 'Avenir Next';
  font-size: 12px;
  color: #a8adba;
`;
